<template>
<section class="ui-section">
    <div class="ui-max-width">
        
        <div class="flex ui-fle-wrap">
            <div class="ui-flex-items-100">
                <img class="headmast__banner-image img-fluid" src="@/assets/images/nurse.png">
            </div>
        <div class="ui-ts-text-wrap flex content-center  flex-wrap	 ui-flex-items-100 __text">
        <div>
            <div class="ui-head">
            <h3 v-html="$t('timeline_head')"></h3>
            <p class="timelin-sub">{{$t('timeline_subtext') }}</p>
            </div>
            <div class="ui-timeline-wrap">
                <div class="ui-timline-item">
                    <img src="@/assets/images/screening1.png">
                    <p class="ui-timeline-head">{{$t('timeline_box1head') }}</p>
                    <p>{{$t('timeline_box1p') }}</p>
                </div>
                <div class="ui-timline-item">
                    <img src="@/assets/images/treatment1.png">
                    <p class="ui-timeline-head">{{$t('timeline_box2head') }}</p>
                    <p>{{$t('timeline_box2p') }}</p>
                </div>
                <div class="ui-timline-item">
                    <img src="@/assets/images/follow1.png">
                    <p class="ui-timeline-head">{{$t('timeline_box3head') }}</p>
                    <p>{{$t('timeline_box3p') }}</p>
                </div>
            </div>

        </div>
        </div>
        </div>
    </div>
</section>
</template>

<script>
//import UiHeadingVue from '../../components/UiHeading.vue'
export default {
 components: {
        //"ui-head": UiHeadingVue
    }
}
</script>


<style lang="scss" scoped>
.ui-section{
    @include about-bg-image;
    background-position: top right;
    padding: 0 16px;
}
/*EDIT COLOURS HERE*/
.ui-ts-heading {
    color: #4e5157;
}

.ui-ts-heading span {
    color: #39a8e3;
}

.ui-ts-subheading {
    color: #39a8e3;
}
.timelin-sub{
    max-width: 500px;
}
.ui-ts-subheading {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 8px;
}

.ui-ts-text-wrap {
    margin-left: 0;
}

.ui-ts-ul {
    list-style: disc;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-ol {
    list-style: decimal;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-li {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 6px;
    padding-left: 8px;
}
.ui-timeline-wrap{
    display: flex;
    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
    }
    .ui-timline-item{
        width: 33%;
        padding: 4px 16px;
        text-align: left;
        @media screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0;
    }
        &:first-child{
            padding-left: 0;
        }
        &:last-child{
            padding-right: 0;
        }
        .ui-timeline-head{
            color:$primary-color;
            font-size: 21px;
            margin-bottom:6px;
        }
    }

}
.ui-fle-wrap{
    flex-wrap: nowrap;
    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
    }
}
.ui-flex-items-100{
    width: 40%;
    &.__text{
        width: 60%;
        margin-left: 50px;
        @media screen and (max-width: 768px) {
            width: 65%;
            margin-left: 20px;
        }
        @media screen and (max-width: 767px) {
            width: 100%;
            margin-left: 0;
        }
    }
    @media screen and (max-width: 768px) {
        width: 28%;
    }
    @media screen and (max-width: 767px) {
        width: 100%;
    }
}
</style>
